export function isStandardAdmissionOffer(offer) {
  if (!offer) return false
  return offer.isDefaultOffer === true || offer.name === 'Standard Admission'
}

function standardAdmissionRank(groupOrOffer) {
  const offer = groupOrOffer?.offer || groupOrOffer
  return isStandardAdmissionOffer(offer) ? 0 : 1
}

export function compareOffersStandardFirst(a, b) {
  return standardAdmissionRank(a) - standardAdmissionRank(b)
}

export function compareQuickpicks(a, b, sort) {
  const defaultDelta = standardAdmissionRank(a) - standardAdmissionRank(b)
  if (defaultDelta !== 0) return defaultDelta

  if (sort === 'bestseat') {
    const seatDelta = (a.sortOrder ?? Infinity) - (b.sortOrder ?? Infinity)
    if (seatDelta !== 0) return seatDelta
    return (a.price ?? Infinity) - (b.price ?? Infinity)
  }

  const priceDelta = (a.price ?? Infinity) - (b.price ?? Infinity)
  if (priceDelta !== 0) return priceDelta
  return (a.sortOrder ?? Infinity) - (b.sortOrder ?? Infinity)
}
